export const products = [{
        id: 1,
        img: "/images/shop-admin.png",
        link: "https://github.com/Astroth1984/Admin-Panel-Shop",
    }, {
        id: 2,
        img: "/images/shop-client.png",
        link: "https://github.com/Astroth1984/e-commerce-app",
    },
    {
        id: 3,
        img: "/images/landing-tem.png",
        link: "https://react-landing-page-template.herokuapp.com",
    },
    {
        id: 4,
        img: "/images/crypto.png",
        link: "https://astroth1984.github.io/React-Crypto-App/",
    },
    {
        id: 5,
        img: "/images/landing.jpg",
        link: "https://investopedia-show-case.netlify.app/",
    },
    {
        id: 6,
        img: "/images/geolane.png",
        link: "https://github.com/Astroth1984/geolane-beta-app",
    },
    {
        id: 7,
        img: "/images/portfolio.png",
        link: "https://github.com/Astroth1984/Portfolio",
    },

];